import React, { useContext, useState } from "react";
import { Button, Steps, theme } from "antd";
import { useNavigate } from "react-router";
import { context } from "../context/context";
import { http } from "../services/httpService";
import config from "../services/config.json";
import { toast } from "react-toastify";
import EventForm from "../components/Events/EventForm";
import EventUploadMedia from "../components/Events/EventUploadMedia";
import { NavLink } from "react-router-dom";

const steps = [
    {
        title: "اضافه کردن جزئیات رویداد",
        content: <EventForm />,
    },
    {
        title: "انتخاب عکس",
        content: <EventUploadMedia />,
    },
];
const AddEvent = () => {
    const { token } = theme.useToken();
    // state
    const [current, setCurrent] = useState(0);
    // context
    const {
        setEventCover,
        setEventMedia,
        eventLinks,
        textEditorHTML,
        eventTitle,
        eventCoverId,
        eventMediaId,
        eventTags,
        setEventMediaId,
        eventStartDate,
        eventEndDate,
    } = useContext(context);
    // functions
    const next = () => {
        setCurrent(current + 1);
    };
    const navigate = useNavigate();
    const handleSubmit = () => {
        http.post(`${config.parkopoloApi}/api/Event/addEvent`, {
            links: eventLinks,
            data: textEditorHTML,
            title: eventTitle,
            date: { start: eventStartDate, end: eventEndDate },
            coverPic: eventCoverId,
            media: eventMediaId,
            tags: eventTags,
        })
            .then((res) => {
                toast.success("رویداد با موفقیت ساخته شد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(res.data.success);
            })
            .catch((err) => {
                toast.error("خطایی رخ داد !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    progress: undefined,
                    theme: "colored",
                    style: { fontFamily: "Vazir" },
                });
                console.log(err);
            });
        setEventMedia([]);
        setEventMediaId([]);
        setEventCover();
        navigate("/events", { replace: true });
    };
    const items = steps.map((item) => ({
        key: item.title,
        title: item.title,
    }));
    const contentStyle = {
        lineHeight: "260px",
        textAlign: "center",
        color: token.colorTextTertiary,
        backgroundColor: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: `1px dashed ${token.colorBorder}`,
        marginTop: 16,
    };
 
    return (
        <div style={{ direction: "ltr" }}>
            <Steps current={current} items={items} />
            <div style={contentStyle}>{steps[current].content}</div>
            <div
                style={{
                    marginTop: 24,
                    textAlign: "left",
                    display: "flex",
                    gap: 10,
                }}
            >
                {current < steps.length - 1 && (
                    <Button
                        type="primary"
                        onClick={() => next()}
                        disabled={
                            current === 0 &&
                            (!eventTitle ||
                                eventTitle === "" ||
                                !eventEndDate ||
                                !eventStartDate)
                        }
                    >
                        مرحله بعد
                    </Button>
                )}
                {current === steps.length - 1 && (
                    <Button
                        disabled={!eventCoverId || eventCoverId === ""}
                        type="primary"
                        onClick={() => handleSubmit()}
                    >
                        ثبت
                    </Button>
                )}
                {
                    <NavLink to="/events">
                        <Button type="primary" danger>
                            لغو
                        </Button>
                    </NavLink>
                }
            </div>
        </div>
    );
};

export default AddEvent;
